'use client';

function addUnlinkedScrollListener(node) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var prevPosition = {
    left: node.scrollLeft,
    top: node.scrollTop
  };
  var rAF = 0;
  (function loop() {
    var position = {
      left: node.scrollLeft,
      top: node.scrollTop
    };
    var isHorizontalScroll = prevPosition.left !== position.left;
    var isVerticalScroll = prevPosition.top !== position.top;
    if (isHorizontalScroll || isVerticalScroll) handler();
    prevPosition = position;
    rAF = window.requestAnimationFrame(loop);
  })();
  return function () {
    return window.cancelAnimationFrame(rAF);
  };
}
export { addUnlinkedScrollListener };